import { createContext, Dispatch, useContext } from "react";
import { Graph_QL, System } from "../../../Services";
import { EsfLocation, EsfSectionsInfo, StationInfo } from "../../../Services/Agrisys_GqlDataCaller/WalkThroughDataCalls/getEsfStructureCall";
import { TerminalInfo } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalsCall";

/* eslint-disable */
export enum currentEsfViewTypes {
  basic = "basic",
  systemControle = "systemControle",
  attention = "attention",
  remainingToday = "remainingToday",
  remainingYesterday = "remainingYesterday"
}

export enum IEsfContextEnum {
  sections = "sections",
  currentPenViewType = "currentPenViewType",
  error = "error",
  penContent = "penContent",

  selectedStations = "selectedPens",
  selectedSection = "selectedSection",

  tempTerminalsData = "tempTerminalsData"
}
/* eslint-enable */

export type IEsfContext = {
  farm: string;
  domain: string;
  connection: Graph_QL.Connection;
  system: System;

  sections?: EsfLocation[];
  currentStationViewType: currentEsfViewTypes;
  penContent?: number;
  error: { Elementid: number, errorText: string };

  selectedStations?: StationInfo[];
  selectedSection?: EsfLocation;
  
  tempTerminalsData?: TerminalInfo[];
};

export type EsfDispatcherT = Deep_Partial<IEsfContext>;

type EsfContexter = {
  state: IEsfContext,
  dispatch: Dispatch<EsfDispatcherT>
}

export const EsfContext = createContext<EsfContexter | undefined>(undefined);

export function EsfReducer(state: IEsfContext, action: EsfDispatcherT) {
  let ResultState = { ...state };
  Object.entries(action).forEach(([type, payload], index) => {
    switch (type) {
      case IEsfContextEnum.selectedSection: {
        const newSection = payload as EsfLocation | undefined;
        const newSectionStations = newSection?.stations.map(loc => loc) ?? [];
        ResultState = {
          ...ResultState,
          selectedSection: newSection,
          selectedStations: newSectionStations,
        };
        break;
      }
      case IEsfContextEnum.selectedStations: {
        ResultState = {
          ...ResultState,
          selectedStations: payload as StationInfo[]
        };
        break;
      }
      case IEsfContextEnum.sections: {
        ResultState = {
          ...ResultState,
          sections: payload as EsfLocation[]
        };
        break;
      }
      case IEsfContextEnum.penContent: {
        ResultState = {
          ...ResultState,
          penContent: payload as number
        };
        break;
      }

      case IEsfContextEnum.currentPenViewType:
        ResultState = {
          ...ResultState,
          currentStationViewType: payload as currentEsfViewTypes
        };
        break;
      
        case IEsfContextEnum.tempTerminalsData:
          ResultState = {
            ...ResultState,
            tempTerminalsData: payload as TerminalInfo[]
          };
          break;
      
      case IEsfContextEnum.error:
        ResultState = {
          ...ResultState,
          error: payload as IEsfContext["error"]
        };
        break;

      default:
        console.error(`Unhandled action type: ${type}`);
        break;
    }
  });
  return ResultState;
}


export const useEsfContext = () => {
  const context = useContext(EsfContext);
  if (!context) {
    throw new Error("usePenContext must be used within a ModalProvider");
  }
  return context;
};